import * as React from 'react';

import { SimpleSticky } from '../SimpleSticky';
import { useModernStickyProps } from './useModernStickyProps';

export interface IModernStickyProps {
  top?: number | string;
  bottom?: number | string;
  zIndex?: number;
  testId?: string;
  onBottomStuck?: (isIntersecting: boolean) => void;
  onTopStuck?: (isIntersecting: boolean) => void;
}

export const ModernSticky: React.FC<React.PropsWithChildren<IModernStickyProps>> = props => {
  const { onBottomStuck, onTopStuck, top, bottom, zIndex, children, testId = 'modernSticky' } = props;
  const { sentinelRef } = useModernStickyProps({ onBottomStuck, onTopStuck });

  return (
    <SimpleSticky ref={sentinelRef} zIndex={zIndex} bottom={bottom} top={top} testId={testId}>
      {children}
    </SimpleSticky>
  );
};

ModernSticky.displayName = 'ModernSticky';
